// localStorage wrapper para sesión de pantalla.
// - token: HMAC firmado por backend, TTL 12h.
// - expires_at: unix seconds.
// - sucursal_id: cacheado para mostrar en UI sin pegar /state.
// - appMode: flag para bloquear acceso a /admin desde esta PC.

const TOKEN_KEY = "juegossc_app_token";
const EXPIRES_KEY = "juegossc_app_expires";
const SUCURSAL_KEY = "juegossc_app_sucursal";
const MODE_KEY = "juegossc_app_mode";

export function getAppToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  // Check expiración local antes de devolver (evita request con token muerto).
  const exp = parseInt(localStorage.getItem(EXPIRES_KEY) ?? "0", 10);
  if (exp && exp < Math.floor(Date.now() / 1000)) {
    clearAppToken();
    return null;
  }
  return token;
}

export function setAppSession(
  token: string,
  expiresAt: number,
  sucursalId: number,
): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_KEY, String(expiresAt));
  localStorage.setItem(SUCURSAL_KEY, String(sucursalId));
  localStorage.setItem(MODE_KEY, "1");
}

export function clearAppToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  // NO borrar SUCURSAL_KEY ni MODE_KEY: el modo pantalla persiste
  // entre sesiones (la PC sigue siendo una pantalla aunque expire el token).
}

export function clearAppMode(): void {
  // Solo se llama cuando explícitamente "salimos del modo pantalla" con PIN.
  localStorage.removeItem(MODE_KEY);
  localStorage.removeItem(SUCURSAL_KEY);
  clearAppToken();
}

export function getAppSucursalId(): number | null {
  const id = localStorage.getItem(SUCURSAL_KEY);
  return id ? parseInt(id, 10) : null;
}

export function isAppMode(): boolean {
  return localStorage.getItem(MODE_KEY) === "1";
}
